// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yPrC","colBig":"styles_colBig__2ul9J","colSmall":"styles_colSmall__ar9Fs"};